export default "/images/d34d1abbf8320fcca8ebaa332aec9336.avif";